module.exports = __webpack_public_path__ + "static/media/select-dropdown.837361c9.svg";